import { render, staticRenderFns } from "./AddStairsService.vue?vue&type=template&id=f6122da2"
import script from "./AddStairsService.vue?vue&type=script&lang=ts"
export * from "./AddStairsService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports